import { atomWithStorage, createJSONStorage } from 'jotai/utils';

export function atomWithSessionStorage(key, initialValue) {
  const storage = createJSONStorage(() => window?.sessionStorage);
  return atomWithStorage(key, initialValue, storage, { getOnInit: true });
}
